// extracted by mini-css-extract-plugin
export default {"langSelect":"LangSelect_langSelect__fCevk","living":"LangSelect_living__3Nrgu","fade":"LangSelect_fade__BpZCj","select":"LangSelect_select__asVED"};